module.exports = __webpack_public_path__ + "img/idamura.4caf975b.jpg";